import auth from './zh-CN/auth';
import button from './zh-CN/button';
import error from './zh-CN/error';
import errorCode from './zh-CN/errorCode';
import global from './zh-CN/global';

export default {
  ...auth,
  ...button,
  ...error,
  ...errorCode,
  ...global,
};
